import { render, staticRenderFns } from "./user-center-info.vue?vue&type=template&id=bab14d32&scoped=true"
import script from "./user-center-info.vue?vue&type=script&lang=js"
export * from "./user-center-info.vue?vue&type=script&lang=js"
import style0 from "./user-center-info.vue?vue&type=style&index=0&id=bab14d32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab14d32",
  null
  
)

export default component.exports